export enum FeedbackType {
  GRAMMAR = 'GRAMMAR',
  PARAPHRASE = 'PARAPHRASE',
  SYNONYM = 'SYNONYM',
  REWRITE = 'REWRITE',
  CLARITY_REASON = 'CLARITY_REASON',
}

export enum ChangeType {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  REPLACE = 'REPLACE',
}

export interface Feedback {
  id: string
  sentenceId: string
  feedbackType: FeedbackType
  score?: number // only for grammar
  changeType?: ChangeType // only for grammar
  position?: {
    // not present for paraphrase
    offset: number
    length: number
  }
  suggestedText: string
  reason?: string // only for paraphrase feedback for now.
}

export interface GrammarFeedback extends Feedback {
  impactedText: string
  sentenceOriginalText: string
}

export type ParaphraseFeedback = Omit<
  GrammarFeedback,
  'typeOfChange' | 'position' | 'score' | 'sentenceOriginalText'
>
